import { GOOGLE_API_KEY } from '../api_keys';

export const MAP_API_URL = `//maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&callback=initMap`;



// WEBPACK FOOTER //
// ./app/javascript/common/map/api_urls.js